var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal", class: { "is-active": _vm.isVisible } },
    [
      _c("div", { staticClass: "modal-background", on: { click: _vm.close } }),
      _c("div", { staticClass: "modal-content modal-medium" }, [
        _c("div", { staticClass: "modal-inner-wrapper" }, [
          _c("a", { staticClass: "modalclose", on: { click: _vm.close } }, [
            _c("i", { staticClass: "fas fa-times" })
          ]),
          _c("h1", [_vm._v(" ARE YOU SURE YOU WANT TO CANCEL? ")]),
          _vm.event
            ? _c(
                "div",
                { staticClass: "event-section" },
                [
                  _c("EventPreview", {
                    attrs: {
                      event: _vm.event,
                      selectedDate: _vm.selectedDate,
                      venue: _vm.venue
                    }
                  }),
                  _vm.willRefund
                    ? _c("div", { staticClass: "warning-icon" }, [
                        _c("img", {
                          attrs: { src: "/img/warning.png", alt: "warning" }
                        })
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.order
            ? _c("div", { staticClass: "customer-info" }, [
                _c("div", { staticClass: "customer-name" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.order.firstName) +
                      " " +
                      _vm._s(_vm.order.lastName) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "customer-email" }, [
                  _vm._v(_vm._s(_vm.order.email))
                ]),
                _c("div", { staticClass: "customer-tickets" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.totalTickets) +
                      " " +
                      _vm._s(_vm.order.tierName) +
                      " "
                  ),
                  _vm.order.checkedin > 0
                    ? _c("span", { staticClass: "checked-in-note" }, [
                        _vm._v(
                          " (" +
                            _vm._s(_vm.order.checkedin) +
                            " already checked in) "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "ticket-selector" }, [
            _c("p", { staticClass: "selector-label" }, [
              _vm._v("How many tickets do you want to cancel?")
            ]),
            _c(
              "div",
              { staticClass: "quantity-buttons" },
              _vm._l(_vm.totalTickets, function(num) {
                return _c(
                  "button",
                  {
                    key: num,
                    staticClass: "quantity-btn",
                    class: { active: _vm.selectedQuantity === num },
                    on: {
                      click: function($event) {
                        _vm.selectedQuantity = num
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(num) + " ")]
                )
              }),
              0
            )
          ]),
          _vm.hasPaymentToRefund
            ? _c("div", { staticClass: "refund-section" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-container",
                    class: {
                      disabled: _vm.selectedQuantity !== _vm.totalTickets
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.willRefund,
                          expression: "willRefund"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.selectedQuantity !== _vm.totalTickets
                      },
                      domProps: {
                        checked: Array.isArray(_vm.willRefund)
                          ? _vm._i(_vm.willRefund, null) > -1
                          : _vm.willRefund
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.willRefund,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.willRefund = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.willRefund = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.willRefund = $$c
                          }
                        }
                      }
                    }),
                    _c("span", { staticClass: "checkmark" }),
                    _vm._v(" Refund purchase ")
                  ]
                ),
                _vm.willRefund
                  ? _c("p", { staticClass: "warning" }, [
                      _vm._v(" Refunded purchases can not be reversed ")
                    ])
                  : _vm._e(),
                _vm.selectedQuantity !== _vm.totalTickets
                  ? _c("p", { staticClass: "refund-note" }, [
                      _vm._v(
                        " Refund is only available when cancelling all tickets "
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "button",
                {
                  staticClass: "button is-fullwidth",
                  attrs: { disabled: _vm.isProcessing },
                  on: { click: _vm.close }
                },
                [_vm._v(" NO, OOPS DON'T ")]
              )
            ]),
            _c("div", { staticClass: "column" }, [
              _c(
                "button",
                {
                  staticClass: "button is-fullwidth is-primary",
                  attrs: {
                    disabled: _vm.isProcessing || _vm.selectedQuantity === 0
                  },
                  on: { click: _vm.confirmCancel }
                },
                [
                  _vm.isProcessing
                    ? _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "fas fa-spinner fa-spin" })
                      ])
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isProcessing
                          ? "PROCESSING..."
                          : "YES, CANCEL TICKET"
                      ) +
                      " "
                  )
                ]
              )
            ])
          ]),
          _vm.processingMessage
            ? _c("div", { staticClass: "processing-status" }, [
                _vm._v(" " + _vm._s(_vm.processingMessage) + " ")
              ])
            : _vm._e(),
          _vm.errorMessage
            ? _c("div", { staticClass: "error-message" }, [
                _vm._v(" " + _vm._s(_vm.errorMessage) + " ")
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }